if (!customElements.get('ingredients-carousel')) {
  customElements.define(
    'ingredients-carousel',
    class IngredientsCarousel extends HTMLElement {
      constructor() {
        super();
        this.viewportNode = this.querySelector('.ingredients-carousel__slider-viewport');
        this.slides = this.querySelectorAll('.ingredients-carousel__slide');
        this.prevBtnNode = this.querySelector('.ingredients-carousel__prev');
        this.nextBtnNode = this.querySelector('.ingredients-carousel__next');

        this.embla = EmblaCarousel(this.viewportNode, { align: 'center', loop: true, slidesToScroll: 1 });
        this.prevBtnNode.addEventListener('click', this.previous.bind(this), false);
        this.nextBtnNode.addEventListener('click', this.next.bind(this), false);

        this.embla
          .on('select', this.togglePrevNextBtnsState.bind(this))
          .on('init', this.togglePrevNextBtnsState.bind(this))
          .on('reInit', this.togglePrevNextBtnsState.bind(this));

        this.modalWrapper = this.querySelector('#modal-wrapper');
        this.modals = this.querySelectorAll('.ingredients-modals__modal');
        this.overlay = this.querySelector('.ingredients-modals');
        this.closeButtons = this.querySelectorAll('.ingredients-modals__close-button');
        this.modalNext = this.querySelector('.ingredients-modals__next');
        this.modalPrev = this.querySelector('.ingredients-modals__prev');

        this.modalNext.addEventListener('click', this.nextModal.bind(this), false);
        this.modalPrev.addEventListener('click', this.prevModal.bind(this), false);

        this.overlayTargets = this.querySelectorAll('.ingredients-modals__modal-overlay');

        this.overlayTargets.forEach((overlayTarget) => {
          overlayTarget.addEventListener('click', this.closeModal.bind(this));
        });

        // Add click event to each close button
        this.closeButtons.forEach((closeButton) => {
          closeButton.addEventListener('click', this.closeModal.bind(this));
        });

        // Add click event to each slide
        this.slides.forEach((slide, index) => {
          slide.addEventListener('click', this.slideClickHandler.bind(this, slide));
        });
      }

      closeModal() {
        this.modals.forEach((modal) => {
          modal.classList.remove('ingredients-modals__modal--active');
        });

        this.overlay.classList.remove('ingredients-modals--active');
      }

      slideClickHandler(slide) {
        const modalId = slide.getAttribute('data-modal-id');

        // Close all modals
        this.closeModal();

        // Open the modal with the same ID as the clicked slide
        const modal = this.querySelector(`#modal-${modalId}`);

        modal.classList.add('ingredients-modals__modal--active');
        this.overlay.classList.add('ingredients-modals--active');
      }

      previous(e) {
        e.preventDefault();
        this.embla.scrollPrev();
      }

      next(e) {
        e.preventDefault();
        this.embla.scrollNext();
      }

      nextModal(e) {
        e.preventDefault();
        const activeModal = this.querySelector('.ingredients-modals__modal--active').getAttribute('data-modal-id');
        const amountOfModals = this.modals.length;
        const nextModalID = parseInt(activeModal) + 1;
        this.querySelector(`#modal-${activeModal}`).classList.remove('ingredients-modals__modal--active');

        if (nextModalID <= amountOfModals - 1) {
          this.querySelector(`#modal-${nextModalID}`).classList.add('ingredients-modals__modal--active');
          return;
        }

        this.querySelector(`#modal-0`).classList.add('ingredients-modals__modal--active');
      }

      prevModal(e) {
        e.preventDefault();
        const activeModal = this.querySelector('.ingredients-modals__modal--active').getAttribute('data-modal-id');
        const amountOfModals = this.modals.length;
        const prevModalID = parseInt(activeModal) - 1;
        this.querySelector(`#modal-${activeModal}`).classList.remove('ingredients-modals__modal--active');

        if (prevModalID >= 0) {
          this.querySelector(`#modal-${prevModalID}`).classList.add('ingredients-modals__modal--active');
          return;
        }

        this.querySelector(`#modal-${amountOfModals - 1}`).classList.add('ingredients-modals__modal--active');
      }

      togglePrevNextBtnsState() {
        if (this.embla.canScrollPrev()) {
          this.prevBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.prevBtnNode.classList.add('arrow-button--disabled');
        }

        if (this.embla.canScrollNext()) {
          this.nextBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.nextBtnNode.classList.add('arrow-button--disabled');
        }
      }
    },
  );
}
